import React, { useRef } from 'react';

import { CtaBtn } from '@tmapy/style-guide';

type UploadBtnProps = {
  isDisabled?: boolean;
  onChange(e: React.ChangeEvent): void;
  children: React.ReactNode;
};

export const UploadBtn: React.FC<UploadBtnProps> = (props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    inputRef.current!.click();
  };

  return (
    <>
      <input
        className='sg-a-d-n'
        ref={inputRef}
        type='file'
        name='files'
        onChange={props.onChange}
        disabled={props.isDisabled}
      />
      <CtaBtn onClick={handleClick}>{props.children}</CtaBtn>
    </>
  );
};
